<template>
  <header class="app-header">
    <div class="logo">
      <n-button v-if="showHamburger" class="hamburger" size="tiny" quaternary @click="$emit('toggle-sidebar')" title="展开题库">
        <template #icon>
          <n-icon><MenuOutline /></n-icon>
        </template>
      </n-button>
      <n-avatar :size="18" round :src="logo" class="logo-icon"></n-avatar>
      <span class="brand brand-link" @click="goHome" title="回到首页">Mathy</span>
    </div>
    <div class="actions">
      <n-popover v-if="showHistory" trigger="click" placement="bottom-end" :show-arrow="false" @update:show="onPopShow">
        <template #trigger>
          <n-button size="small" quaternary title="历史记录">
            <template #icon>
              <n-icon><TimeOutline /></n-icon>
            </template>
            历史
          </n-button>
        </template>
        <div class="history-pop">
          <n-list v-if="Array.isArray(history) && history.length" hoverable clickable>
            <n-list-item v-for="it in history" :key="it.id" @click="select(it.id)">
              <div class="row">
                <span class="id">{{ it.id }}</span>
                <span class="time">{{ formatTime(it.createdAt) }}</span>
              </div>
            </n-list-item>
          </n-list>
          <div v-else class="empty">暂无历史</div>
        </div>
      </n-popover>
      <n-button size="small" quaternary @click="$emit('toggle-theme')">
        <template #icon>
          <n-icon><component :is="isDark ? SunnyOutline : MoonOutline" /></n-icon>
        </template>
      </n-button>
    </div>
  </header>
</template>

<script setup>
import { NAvatar, NButton, NIcon, NPopover, NList, NListItem } from 'naive-ui'
import { SchoolOutline, SunnyOutline, MoonOutline, TimeOutline, MenuOutline } from '@vicons/ionicons5'
import logo from '../assets/logo.svg'
const props = defineProps({
  gradeLabel: { type: String, default: '选择年级' },
  isDark: { type: Boolean, default: true },
  history: { type: Array, default: () => [] },
  showHamburger: { type: Boolean, default: true },
  showHistory: { type: Boolean, default: true }
})
const emit = defineEmits(['open-grade', 'toggle-theme', 'select-history', 'refresh-history', 'go-home'])
// 透传: toggle-sidebar

function select(id) {
  emit('select-history', id)
}
function onPopShow(v) {
  if (v) emit('refresh-history')
}
function formatTime(ts) {
  try {
    const d = new Date(Number(ts) || 0)
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    const hh = String(d.getHours()).padStart(2, '0')
    const mi = String(d.getMinutes()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}`
  } catch (e) {
    return ''
  }
}
function goHome() {
  emit('go-home')
}
</script>

<style scoped>
.app-header {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid var(--header-border);
  background: var(--header-bg);
  backdrop-filter: blur(6px);
}
.logo {
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 600;
}
.logo-icon {
  padding: 5px;
}
.brand {
  color: var(--header-text);
  font-size: 14px;
  letter-spacing: 0.02em;
}
.brand-link {
  cursor: pointer;
}
/* 提升浅色主题下的 Logo 可读性 */
:deep(.n-avatar) {
  background: var(--logo-bg);
  color: var(--logo-text);
}
.history-pop {
  width: 320px;
  max-height: 60vh;
  overflow: auto;
}
.row {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
}
.id {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.time {
  color: #94a3b8;
  font-size: 12px;
}
.empty {
  color: #94a3b8;
  font-size: 12px;
  padding: 6px 8px;
}
</style>
